<template>
  <div>
    <div
      class="modal fade"
      id="alert-exceedlimit"
      data-backdrop="static"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div
          ref="section"
          class="modal-content"
        >
          <div class="modal-header bg-danger">
            <h5 class="modal-title">
              <!-- {{
                $t('Usage Exceeds Plan Limits!')
              }} -->
              {{ $t('Manage Plan') }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-exceed alert-dismissible text-danger mb-2 d-flex align-items-start"
            >
              <div class="d-flex">
                <span class="font-weight-bold mr-1">
                  <i class="fa-solid fa-circle-exclamation pr-1" />
                </span>
              </div>
              <span>
                {{ $t('More Information:') }}
                {{ $t("Your store has been downgraded! Please manage your usage based on your plan limits or please press the") }}
                <b>'{{ $t("Upgrade Now!") }}'</b>
                {{ $t("button to continue using it.") }}
              </span>
            </div>
            <!-- <p>{{ $t("Feature Limit Exceeded") }} {{ $t('(1)') }} :</p> -->
            <div
              v-if="wmsWarehouseLimit"
              class="d-flex align-items-start border-bottom mb-2 pb-4">
               <img
                 :src="require(`@/assets/global_assets/images/inventory/inventory-icon.png`)"
                 width="35"
                 height="35"
                 alt="Logo"
                 class="img-fluid mt-1"
               >
               <div class="flex-fill ml-2 mr-2">
                 <div class="d-flex">
                   <span class="mb-1">{{ $t("Inventory") }}</span>
                 </div>
                 <div class="d-flex align-content-center">
                   <span>
                     {{ $t('This feature cannot be used, because it exceeds the maximum connection limit') }} {{ $parent.limitWarehouses }} {{ $t('for your plan. Click the') }} <b>'{{ $t("Manage") }}'</b> {{ $t('or') }} <b>'{{ $t("Upgrade Now!") }}'</b> {{ $t('button to continue using it.') }}
                   </span>
                 </div>
               </div>
               <button
                 type="button"
                 class="btn btn-outline-primary align-self-end"
                 @click="showModalManageWarehouse"
               >
                 {{ $t('Manage') }}
               </button>
             </div>
            <div
              v-if="$store.state.user.showExceed"
              class="d-flex align-items-start">
              <img
                :src="require(`@/assets/images/integration/Social_logo.png`)"
                width="35"
                height="35"
                alt="Logo"
                class="img-fluid mt-1"
              >
              <div class="flex-fill ml-2 mr-2">
                <div class="d-flex">
                  <span class="mb-1">Social Commerce</span>
                </div>
                <div class="d-flex align-content-center">
                  <span>
                    {{ $t('This feature cannot be used, because it exceeds the maximum connection limit') }} {{ limitPage }} {{ $t('for your plan. Click the') }} <b>'{{ $t("Manage") }}'</b> {{ $t('or') }} <b>'{{ $t("Upgrade Now!") }}'</b> {{ $t('button to continue using it.') }}
                  </span>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-outline-primary align-self-end"
                @click="showModalExceedLimitList"
              >
                {{ $t('Manage') }}
              </button>
            </div>
          </div>
          <div class="modal-footer pb-2 pt-4">
            <!-- <a
              class="mr-2 text-primary cursor-pointer"
              @click="skip"
            >
              {{ $t('Skip') }}
            </a> -->
            <button
              type="button"
              class="btn btn-outline-primary align-self-end"
              @click="skip"
             >
              {{ $t('Skip') }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="redirctUpgradePlan"
            >
              <i class="fa-solid fa-medal mr-1" />
              {{ $t("Upgrade Now!") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/services/endpoint/tenant.service.js";
import Cookies from "js-cookie";
export default {
  name: "AlertExceedLimit",
  components: {
  },
  data() {
    return {
      alertExceedLinit: false,
      onload: true,
      limitPage: 10,
      isShowAlert:false,
      wmsWarehouseLimit: JSON.parse(Cookies.get('WmsWarehouseLimit'))
    };
  },
  methods: {
    // getExceedLimit: async function () {
    //   const exeedLimit = await Api.PlanSubscription.getExceedLimit();
    //   // if(exeedLimit.data.data.length > 0){
    //     $("#alert-exceedlimit").modal('show');
    //   // }

    // },
    showModalManageWarehouse : async function () {
      this.$emit('showManageWarehouse')
    },
    showModalExceedLimitList : async function () {
      this.$emit('showPageList')
    },
    redirctUpgradePlan : async function (){
      $("#alert-exceedlimit").modal('hide');
      let vm = this;
      setTimeout(function(){
        vm.$router.push({
          name: 't.a.premium.subscriptions',
        })
      },1000);
    },
    skip(){
      $("#alert-exceedlimit").modal('hide');
      let vm = this;
       if (vm.$route.path == '/app/inventories'
       || vm.$route.path == '/app/adjustments'
       || vm.$route.path == '/app/warehouses'
       || vm.$route.path == '/app/purchases'
       || vm.$route.path == '/app/tools/import-products')
       {
         setTimeout(function(){
           vm.$router.push({
             name: 't.a.home',
           })
         },1000);
       }
    }
  },
  mounted() {

  },
  watch: {

  },
};
</script>
<style>

.alert-exceed {
    color: #f44336;
    background-color: #fde1df;
}

.button-next-prev-nas {
  margin-right: -30px;
  float: right;
  color: white;
}

.button-color-nas-next-prev {
  background-color: #ff7043;
  border: 0px;
  color: white;
}

.alert .carousel .left.carousel-control,
.alert .carousel .right.carousel-control {
  background-image: none;
  color: inherit;
  text-shadow: none;
  width: 2%;
  opacity: 1;
}

.alert .carousel .item {
  height: 30px;
}

.alert .carousel-caption-nas {
  padding: 0;
  bottom: 5px;
  left: 4%;
  text-align: left;
  text-shadow: none;
}

/*
  remove margin-bottom
  */
.no-bottom-margin {
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/AlertExceedLimit.vue